import {handleActions} from 'redux-actions';
import {Record, List, Map} from 'immutable';

import FoodConsumptionActionTypes from 'web-app/react/entities/meals/food-consumption/action-types';

import ActionTypes from './action-types';

const MealRegistrationState = Record({
    isVisible: Boolean(false),
    showFoodSelection: Boolean(false),
    institutionId: String(),
    childId: String(),
    mealRegistrationId: String(),
    childIds: List(),
    childNames: String(''),
    foodItemSearchTerm: String(''),
    searchInputFieldText: String(''),
    removing: Map(),
    saving: Map(),
    loading: Boolean(false),
    canEdit: Boolean(true),
    isSubmitting: false,
    openedAt: Date(),
});

export default handleActions(
    {
        [ActionTypes.MEALS_MEAL_REGISTRATION_SHOW]: (state, {payload}) =>
            state.merge({
                canEdit: true,
                isVisible: true,
                showFoodSelection: false,
                institutionId: payload.institutionId,
                childIds: List.of(...payload.childIds),
                childNames: payload.childNames,
                openedAt: new Date(),
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_EDIT]: (state, {payload}) =>
            state.merge({
                canEdit: true,
                isVisible: true,
                showFoodSelection: true,
                institutionId: payload.institutionId,
                mealRegistrationId: payload.mealRegistrationId,
                childIds: List(),
                childNames: '',
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_VIEW]: (state, {payload}) =>
            state.merge({
                canEdit: false,
                childId: payload.childId,
                isVisible: true,
                showFoodSelection: true,
                institutionId: payload.institutionId,
                mealRegistrationId: payload.mealRegistrationId,
                childIds: List(),
                childNames: '',
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_HIDE]: () => new MealRegistrationState(),
        [ActionTypes.MEALS_MEAL_REGISTRATION_CANCEL]: () => new MealRegistrationState(),
        [ActionTypes.MEALS_MEAL_REGISTRATION_SHOW_FOOD_SELECTION]: state => state.merge({showFoodSelection: true}),
        [ActionTypes.MEALS_MEAL_REGISTRATION_HIDE_FOOD_SELECTION]: state => state.merge({showFoodSelection: false}),
        [ActionTypes.MEALS_MEAL_REGISTRATION_FOOD_ITEM_SEARCH]: (state, {payload}) =>
            state.merge({
                foodItemSearchTerm: payload.searchTerm,
                searchInputFieldText: payload.searchTerm,
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_FOOD_ITEM_WRITE_SEARCH]: (state, {payload}) =>
            state.merge({searchInputFieldText: payload.searchTerm}),
        [ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM]: state =>
            state.merge({
                loading: true,
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_SUCCESS]: state =>
            state.merge({
                loading: false,
            }),
        [ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_FAILED]: state =>
            state.merge({
                loading: false,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_DELETE]: (state, {payload}) =>
            state.set('removing', state.get('removing').set(payload.mealRegistrationId, true)),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_DELETE_ABORTED]: (state, {payload}) =>
            state.set('removing', state.get('removing').delete(payload.mealRegistrationId)),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_DELETE_FAILED]: (state, {payload}) =>
            state.set('removing', state.get('removing').delete(payload.mealRegistrationId)),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_DELETE_SUCCESS]: () => new MealRegistrationState(),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE]: (state, {payload}) =>
            state.merge({
                saving: state.get('saving').set(payload.mealRegistration.id, true),
                isSubmitting: true,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE_SUCCESS]: (state, {payload}) =>
            state.merge({
                saving: state.get('saving').delete(payload.mealRegistrationId),
                isSubmitting: false,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATION_UPDATE_FAILED]: (state, {payload}) =>
            state.merge({
                saving: state.get('saving').delete(payload.mealRegistrationId),
                isSubmitting: false,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE]: state =>
            state.merge({
                isSubmitting: true,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE_SUCESS]: state =>
            state.merge({
                isSubmitting: false,
            }),
        [FoodConsumptionActionTypes.MEAL_REGISTRATIONS_CREATE_FAILED]: state =>
            state.merge({
                isSubmitting: false,
            }),
    },
    new MealRegistrationState(),
);
